module.exports = "/packs/010-96f827c3eb4c1705f7fb18a27d2a2534.jpg";